import React from "react";
import Box from "../../../Unknown/Box";
import { GridColDef } from "../../../Unknown/DataGrid";
import Typography from "../../../Unknown/Typography";
import { AppointmentPayment } from "../types";

type ColumnTranslations = {
  headerPaidBy: string;
};

const getColumnPaidBy = (params: {
  translations: ColumnTranslations;
  headerClassName: string;
}): GridColDef<AppointmentPayment, string> => {
  const { translations, headerClassName } = params;

  return {
    field: "customerName",
    disableColumnMenu: true,
    sortable: false,
    headerName: translations.headerPaidBy,
    flex: 1,
    headerClassName,
    renderCell: ({ row }) => {
      const { method } = row;

      const isCard = ["card", "card_present"].includes(method);
      const transactionId = isCard ? row.transactionId : "";

      return (
        <Box width="100%" overflow="hidden">
          <Typography
            variant="body2"
            color="text.primary"
            textOverflow="ellipsis"
            overflow="hidden"
            title={row.customerName}
          >
            {row.customerName}
          </Typography>
          <Typography
            variant="body2"
            fontSize={13}
            textOverflow="ellipsis"
            color="text.secondary"
            overflow="hidden"
            title={transactionId}
          >
            {transactionId}
          </Typography>
        </Box>
      );
    },
  };
};

export default getColumnPaidBy;
